import base64url from 'base64url';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';

const ALLOWED_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
const CODE_VERIFIER_LENGTH = 43;

export const generateCodeVerifier = (): string => {
  const result = [];
  const charactersLength = ALLOWED_CHARACTERS.length;
  for (let i = 0; i < CODE_VERIFIER_LENGTH; i++) {
    result.push(ALLOWED_CHARACTERS.charAt(Math.floor(Math.random() * charactersLength)));
  }
  return result.join('');
};

export const generateCodeChallenge = (codeVerifier: string): string => {
  const hashDigest = sha256(codeVerifier);
  const base64Digest = Base64.stringify(hashDigest);
  const codeChallenge = base64url.fromBase64(base64Digest);
  return codeChallenge;
};
